import { downloadAndTrackFile } from '~/common/trackFileDownload';
import type { MapFulfillmentRequest } from '~/common/types';

/** Hands a request's CEII file to the browser through the attachment link the API signed for it. */
export function downloadCeiiFile(
  ceiiFile: NonNullable<MapFulfillmentRequest['ceiiFile']>,
  requestId: string | undefined,
) {
  const { downloadPath, name } = ceiiFile;
  return downloadAndTrackFile({ name }, { source: 'ceii', request_id: requestId }, async () => {
    if (!downloadPath) throw new Error('No download link');
    return { url: downloadPath, filename: name };
  });
}
